import React from 'react';
import { Row, Col, Card, Button } from 'antd';
import { connect } from 'react-redux';
import cover1 from '../../assets/home-featured-1.jpg';
import cover2 from '../../assets/home-featured-2.jpg';
import cover3 from '../../assets/home-featured-3.jpg';

const intl = {
  headline: {
    'en': 'The iLEAD Principles',
    'dk': 'iLEAD Principperne'
  },
  readmore: {
    'en': 'Read more',
    'dk': 'Læs mere',
  }
}
function Article({ title, cover, language, link }) {
  return (
    <div className="article-card">
      <Card style={{ width: '100%', border: 'none', borderRadius: 0 }} bodyStyle={{ padding: 0 }}>
        <div
          className="custom-image"
          style={{
            width: '100%',
            height: '340px',
            background: `url(${cover}) no-repeat center center`,
            backgroundSize: 'cover',
          }}
        />
        <div className="custom-card">
          <Button
            type="primary"
            href={link}
            style={{ marginBottom: '10px' }}
          >
            {intl.readmore[language]}
          </Button>
          <p style={{ fontSize: '14px', lineHeight: '15px' }}>{title}</p>
        </div>
      </Card>
    </div>
  );
}

function FeaturedArticles(props) {
  const list = props.articles.map(({ title, cover, link }) => (
    <Col md={8}>
      <Article title={title[props.language]} cover={cover} language={props.language} link={link} />
    </Col>
  ));
  return (
    <Row style={{ backgroundColor: '#000' }}>
      <Col sm={24} md={{ span: 12, offset: 6 }}>
        <div style={{ padding: '20px 0px 50px' }}>
          <hr />
          <div
            style={{
              color: '#fff',
              backgroundColor: '#000',
              display: 'inline-block',
              padding: '0 20px',
              top: '-25px',
              position: 'relative',
              fontSize: '20px',
            }}
          >
            {intl.headline[props.language]}
          </div>
        </div>
      </Col>
      <Col
        sm={24}
        md={{ span: 12, offset: 6 }}
        style={{ position: 'relative', zIndex: 1, marginBottom: '-160px' }}
      >
        <Row gutter={24}>{list}</Row>
      </Col>
    </Row>
  );
}

function mapStateToProps(state) {
  return {
    language: state.preference.language,
  }
}

export default connect(mapStateToProps)(FeaturedArticles);

FeaturedArticles.defaultProps = {
  articles: [
    { title: { en: 'Organization - More than only structure', dk: 'Organisationer - Mere end blot struktur' }, cover: cover1, link: '/methodology#orgDynamics' },
    { title: { en: 'Culture - What is it and why is it important?', dk: 'Kultur - Hvad er det og hvorfor er det vigtigt?' }, cover: cover2, link: '/services#serviceColums' },
    { title: { en: 'Communication - Building relations together', dk: 'Kommunikation - Bygge relationer sammen' }, cover: cover3, link: '/services#serviceColums' },
  ],
};



// WEBPACK FOOTER //
// ./src/components/FeaturedArticles/index.js